import React, {FunctionComponent, useCallback, useContext, useEffect, useState} from "react";
import "./VariantProposalModal.scss";
import {InvoiceOption} from "../../models/item.model";
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import {OptionContext} from "../../context/OptionContext";
import {PageContext} from "../../context/PageContext";
import {FullScreenModal} from "../Modal/FullScreenModal";
import {Button} from "../ui-components/Button/Button";
import {PaymentModal} from "../PaymentModal/PaymentModal";
import {InvoicePaymentAmountRows} from "../InvoiceSummary/InvoicePaymentAmountRows";
import {getVariantProposalOptionTitle} from "./VariantProposalCard";

interface VariantProposalAcceptedModalProps {
    option: InvoiceOption | null;
}

export const VariantProposalAcceptedModal: FunctionComponent<VariantProposalAcceptedModalProps> = ({option}) => {
    const invoice: Invoice = useContext(InvoiceContext);
    const optionContext = useContext(OptionContext);
    const pageContext = useContext(PageContext);
    const pdfUrl = pageContext.pageData.pdf_url;
    const [isPaymentModalVisible, setPaymentModalVisible] = useState<boolean>(false);

    const isPaymentAcceptedSignaturePage = pageContext.isPaymentAcceptedSignaturePage();
    useEffect(() => {
        if (isPaymentAcceptedSignaturePage) {
            setPaymentModalVisible(true);
        }
    }, [isPaymentAcceptedSignaturePage]);

    const onClickPayNow = useCallback(() => {
        setPaymentModalVisible(true);
    }, []);

    const onClosePaymentModal = useCallback(() => {
        setPaymentModalVisible(false);
        pageContext.setPaymentAcceptedSignatureMode(false);
    }, [pageContext]);

    const isPayNowVisible = invoice.is_payment_available && parseFloat(optionContext.getPaymentAmount() || '0') > 0;

    return (
        <FullScreenModal customClass="variant-proposal-accepted-modal">
            <header>
                <div className="acceptance-modal-title">
                    <span className="acceptance-modal-subtitle">You accepted</span>
                    <h1>{getVariantProposalOptionTitle(option)}</h1>
                </div>
            </header>

            <main className="acceptance-modal-main">
                <section className="accepted-summary-card">
                    <h3 className="accepted-title">
                        <i className="fa-regular fa-circle-check"></i>
                        {invoice.invoice_name} Accepted
                    </h3>

                    {invoice.is_payment_available && <>
                        {invoice.is_amount_paid_visible &&
                            <div className="summary-item total-summary-item">
                                <p>Amount Paid: </p>
                                <p>{invoice.amount_paid}</p>
                            </div>}
                        <InvoicePaymentAmountRows/>
                    </>}

                    {pdfUrl && <p className="accepted-pdf-link">
                        Download the <a href={pdfUrl} download={true} target="_blank" rel="noreferrer">PDF</a>
                    </p>}
                </section>
            </main>

            <footer className="acceptance-modal-footer">
                {isPayNowVisible &&
                    <Button onClick={onClickPayNow} className="payment-button green-button">
                        <i className="fa-regular fa-cart-shopping"></i>
                        Pay Now
                    </Button>}
            </footer>

            {isPaymentModalVisible && <PaymentModal onCloseModal={onClosePaymentModal}/>}
        </FullScreenModal>
    );
};
